import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import UISpinner from 'Components/UIComponents/UISpinner';

interface DocumentHeaderButtonProps
  extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
  title?: string;
  icon?: string;
  iconType?: 'stroke' | 'fill';
  onClick?: () => Promise<void> | void;
  isLoading?: boolean;
  isMobile?: boolean;
  collapsed?: boolean;
  small?: boolean;
  priority?: 'navigate' | 'cancel';
  iconClassName?: string;
}

const DocumentHeaderButton = ({
  title,
  icon,
  onClick,
  isLoading = false,
  disabled = false,
  iconType = 'stroke',
  isMobile,
  collapsed = false,
  small = false,
  priority,
  iconClassName,
  className,
  children,
  ...buttonProps
}: DocumentHeaderButtonProps) => {
  const buttonClass = classNames(
    'documentHeaderButton',
    {
      'documentHeaderButton--small': small,
      'documentHeaderButton--collapsed': collapsed,
      'documentHeaderButton--mobile': isMobile,
      'documentHeaderButton--loading': isLoading,
      'documentHeaderButton--navigate': priority === 'navigate',
      'documentHeaderButton--cancel': priority === 'cancel',
      [`documentHeaderButton--${iconType}`]: iconType,
    },
    className,
  );

  const iconClass = classNames('documentHeaderButton__icon', iconClassName);

  return (
    <button
      disabled={disabled || isLoading}
      className={buttonClass}
      onClick={onClick}
      {...buttonProps}
    >
      {isLoading && (
        <UISpinner wrapperClassName="spinner__wrapper spinner__wrapper--overlay spinner__wrapper--full-cover spinner__wrapper--bg-gray spinner__wrapper--rounded" />
      )}
      {icon && <ReactSVG src={icon} className={iconClass} wrapper="span" />}
      {!collapsed && (title || children) && (
        <span className="documentHeaderButton__text">{children || title}</span>
      )}
    </button>
  );
};

export default DocumentHeaderButton;
